import React from 'react'
import {
    AllEvents,
    BreakingNewsCard,
    createCardClickedEvent,
    useFeature,
} from '@news-mono/web-common'
import {
    StyledFiftyOffPromoStrapContainer,
    StyledFiftyOffTextImage,
    StyledInnerContainer,
} from './FiftyOffPromoStrap.styled'

export interface FiftyOffPromoStrapProps {
    bannerLink: string
    text: string
    onEvent: (event: AllEvents) => void
    impressionRef: React.RefObject<HTMLDivElement>
}

export const FiftyOffPromoStrap = ({
    bannerLink,
    text,
    onEvent,
    impressionRef,
}: FiftyOffPromoStrapProps) => {
    const hideOnMobileAndApp = useFeature(
        'hide-mobile-breaking-news-banner',
        true,
    )

    const item: BreakingNewsCard = {
        shortHeadline: '50% Off New Subscriptions | Limited Time Only',
        link: bannerLink,
        cardType: 'breaking-news',
        listId: 'fifty-percent-off-promo-strap',
    }
    const linkClicked = () => {
        onEvent(
            createCardClickedEvent(
                onEvent,
                item,
                'FiftyPercentOffPromoStrap',
                'FiftyPercentOffPromoStrap',
                1,
            ),
        )
    }

    const desktopText = require(`./assets/FiftyOffText.svg`)

    return (
        <div ref={impressionRef}>
            <StyledFiftyOffPromoStrapContainer
                hideOnMobileAndApp={hideOnMobileAndApp}
                href={bannerLink}
                onClick={linkClicked}
            >
                <StyledInnerContainer>
                    <StyledFiftyOffTextImage src={desktopText} alt={text} />
                </StyledInnerContainer>
            </StyledFiftyOffPromoStrapContainer>
        </div>
    )
}
